import type { FaireProductEntity } from "../../entity_types/product";

export const p_9a2vuaxpcs: FaireProductEntity = {
  token: "p_9a2vuaxpcs",
  type: "product",
  name: "Leaning Tower of Cupcakes Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/0a85794dede382c4a60c49275f74488a1b129c3cf3d39a197cb28191defc4a22.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7151f2d476120f117090ae2e49e3e35850d3ee8524c1c7d6a91eb252b336c3d5.jpeg",
    "https://cdn.faire.com/fastly/46028691c7db88a5391ef7ca383d4264ec0458353a605834a81dd73c775175af.jpeg",
  ],
  priceDollars: 3,
  description: "Our cupcake pans were working overtime for this one...",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:22.536Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
